import { render } from "./BoardGame.vue?vue&type=template&id=3723e296&scoped=true"
import script from "./BoardGame.vue?vue&type=script&lang=js"
export * from "./BoardGame.vue?vue&type=script&lang=js"

import "./BoardGame.vue?vue&type=style&index=0&id=3723e296&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tchutchu/tchutchu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3723e296"]])

export default __exports__